(function(angular, schoolwork12) {
	'use strict';

	schoolwork12.app.header = {
		name : 'schoolwork12.header',
		controllers : {
			headerController : 'headerController'
		},

		templates : {
			header : 'header/html/header.html'
		},

		endpoints : {
			refreshKeycodeEndpoint : schoolwork12.app.endpoint
					.concat('/user/refreshKeycode'),
		}
	};

	angular.module(schoolwork12.app.header.name, []);
}(angular, schoolwork12));